import jwtDecode from 'jwt-decode';
// routes
import { PATH_AUTH } from '../routes/paths';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode<{ exp: number }>(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// setTimeout stores its delay in a 32-bit signed int; any delay greater than
// 2^31-1 ms (~24.8 days) overflows and fires almost immediately instead of at the
// intended time. Long-lived tokens (the mobile group-session token is ~30 days)
// exceed this, which made the "session expired" redirect fire on load and bounce
// the WebView to /auth/login. Re-arm in bounded chunks so the redirect only fires
// at the real expiry time.
const MAX_TIMEOUT_DELAY = 2 ** 31 - 1;

// Module-scoped so a subsequent setSession() can actually clear the previous timer
// (a function-local `let` never could — clearTimeout ran against a fresh undefined).
let expiredTimer: ReturnType<typeof setTimeout> | undefined;

const handleTokenExpired = (exp: number) => {
  const timeLeft = exp * 1000 - Date.now();

  clearTimeout(expiredTimer);

  if (timeLeft > MAX_TIMEOUT_DELAY) {
    // Can't represent this delay in a single setTimeout; re-check once we're in range.
    expiredTimer = setTimeout(() => handleTokenExpired(exp), MAX_TIMEOUT_DELAY);
    return;
  }

  expiredTimer = setTimeout(() => {
    alert('Your session has expired. Please login again.');

    localStorage.removeItem('accessToken');

    window.location.href = PATH_AUTH.login;
  }, Math.max(0, timeLeft));
};

const setSession = (accessToken: string | null, isAdmin?: boolean) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode<{ exp: number }>(accessToken); // ~3 days by minimals server
    handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.authorization;
  }

  localStorage.setItem('isAdmin', String(Boolean(isAdmin)));
};

const wasAdmin = () => Boolean(localStorage.getItem('isAdmin'));

export { isValidToken, setSession, wasAdmin };
